import { render, staticRenderFns } from "./course-show.vue?vue&type=template&id=f112f098&scoped=true&"
import script from "./course-show.vue?vue&type=script&lang=js&"
export * from "./course-show.vue?vue&type=script&lang=js&"
import style0 from "./course-show.vue?vue&type=style&index=0&id=f112f098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f112f098",
  null
  
)

export default component.exports